"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EAutreCgpCorporationGroupsTrads = void 0;
exports.EAutreCgpCorporationGroupsTrads = {
    appreciationClientCorporation: "Votre appréciation sur le client",
    appreciationOperationCorporation: "Votre appréciation sur l'opération",
    commentConnuConsultimCorporation: "Comment avez-vous connu Consultim Asset Management ?",
    modeEntreeRelationCorporation: "Mode d'entrée en relation",
    dateEntreeRelationCorporation: "Date d'entrée en relation",
    coherenceSituationPatrimonialeInvestCorporation: "Coherence entre la situation patrimoniale et l'investissement",
};
